// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__135ht","col":"styles_col__2Q95e"};